import { useMemo } from 'react'

import { addressFuncs } from '@fv/client-core'
import type { SelectFieldOption } from '@fv/client-types'

import { InputGroup } from '@/components/inputs/InputGroup'
import type { FormSectionProps } from '@/components/inputs/types'

import { useBookingFormCtx } from './BookingFormProvider'
import { requireRateLocation } from './bookFuncs'

export const LTLRateLocation = ({ disabled }: FormSectionProps) => {
  const { setRateLocationType } = useBookingFormCtx(s => s.actions)
  const isFreightCollect = useBookingFormCtx(s => !!s.isFreightCollect)
  const rateLocationType = useBookingFormCtx(s => s.rateLocationType)
  const locations = useBookingFormCtx(s => s.locations)

  const options: SelectFieldOption[] = useMemo(() => {
    if (!requireRateLocation(locations, isFreightCollect)) return []
    return locations.map(x => ({
      text: addressFuncs.streetAddress(x),
      value: x.type,
    }))
  }, [locations, isFreightCollect])

  if (!options.length) return null

  return (
    <div className="border-fv-gray mb-8 border bg-fv-gray-100 px-4 pb-2 pt-4">
      <div className="form-row">
        <InputGroup
          className="basis-full"
          inputProps={{
            disabled,
            name: 'rateLocationType',
            onChange: setRateLocationType,
            options,
            value: rateLocationType,
          }}
          inputType="select"
          label="Which account would you like to use to rate this shipment?"
        />
      </div>
    </div>
  )
}
